import { nothing as r } from "lit";
import { classMap as e } from "lit/directives/class-map.js";
import { ifDefined as C } from "lit/directives/if-defined.js";
import { unsafeStatic as d, literal as i, html as l } from "lit/static-html.js";
import { getCustomElementSuffix as a } from "../../api/custom-element-scope.js";
const S = i`dss-icon${d(a())}`, u = i`dss-icon-button${d(a())}`, y = i`dss-selector${d(a())}`, f = i`dss-chip${d(a())}`, c = i`dss-tooltip${d(a())}`, A = (s) => {
  var _, t, $, h, b, p, w, v;
  const D = {
    "dss-input-wrapper": !0,
    "dss-input-wrapper--required": s._required,
    "dss-input-wrapper--disabled": s._disabled,
    [`dss-input-wrapper--${s.inputSize}`]: !!s.inputSize
  }, T = {
    "dss-input-group": !0,
    [`dss-input-group--${s.inputSize}`]: !!s.inputSize,
    "dss-input-group--invalid": s._invalid || !s._inputValidity,
    "dss-input-group--required": s._required,
    "dss-input-group--disabled": s._disabled,
    "dss-input-group--focused": ((_ = s._input) == null ? void 0 : _.value) || s._placeHolder || s._isFocused,
    "dss-input-group--read-only": s._readonly,
    "dss-input-group--no-label": !s._label,
    "dss-input-group--read-only-empty": ((t = s._input) == null ? void 0 : t.readOnly) && (($ = s._input) == null ? void 0 : $.placeholder) === "" && !((h = s._input) != null && h.value)
  }, k = {
    "dss-input-help": !0,
    "dss-input-help--invalid": s._invalid,
    "dss-input-help--disabled": s._disabled
  }, x = {
    "dss-selector": !s._openWithSearch,
    "dss-selector--visible": s._showDropdown,
    "dss-selector--open-with-search": s._openWithSearch,
    "dss-selector--disabled": s._disabled,
    "dss-selector-dropdown": !0,
    "dss-selector--md": !s._openWithSearch && s.inputSize === "md",
    "dss-selector--loading": !s._popperInstance && !s.openWithSearch
  };
  return l`

    <div class="${e(D)}" style=${C(s._boxStyle ?? void 0)}>

      ${s.inputSize === "sm" ? l`
        <div class="${e({
    "dss-wrapper-label": !0,
    "dss-wrapper-label--invalid": s._invalid
  })}"
        >
          <slot name="label" @click=${s._focusInput}></slot>
        </div>
        ` : r}

      <div class="dss-input-dropdown-wrapper">
        <div class="${e(T)}">

          ${s.icon && s.icon !== "" ? l`
            <${S} icon="${s.icon}" class="dss-input-icon"></${S}>
            ` : r}

          <div class="dss-input-field">
            ${s.inputSize !== "sm" ? l`
              <slot name="label" @click=${s._focusInput}></slot>
              ` : r}
            <slot name="input"
              @click=${s._handleClick}
              @input=${s._handleInput}
              @focusin=${s._handleFocusIn}
              @focusout=${s._handleFocusOut}
              @keydown=${s._handleKeyDown}
              @mouseover=${s._handleInputMouseOver}
            ></slot>

            ${!s._showDropdown && s._isTruncated && s._selectedValue && ((b = s._selectedValue) == null ? void 0 : b.length) === 1 ? l`
                <${c}>${(p = s._input) == null ? void 0 : p.value}</${c}>
              ` : null}


          </div>

          ${s.multiple && s._isTruncated && s._selectedValue && ((w = s._selectedValue) == null ? void 0 : w.length) > 1 ? l`
              <${f}
                label="${s._selectedValue.length}"
                size="xs"
                ?selected=${s._showDropdown}
                @onToggle=${s._toggleDropdown}>
              </${f}>
            ` : null}

          ${!s._openWithSearch && !s._readonly ? l`
                <${u}
                  class="dss-icon-button dss-input-dropdown__toggle"
                  size="md"
                  icon="${s._showDropdown ? "keyboard_arrow_up" : "keyboard_arrow_down"}"
                  label="${s._showDropdown ? "Tancar dropdown" : "Obrir dropdown"}"
                  hideTooltip
                  ariaExpanded="${s._showDropdown}"
                  variant="primary"
                  ?disabled=${s._disabled}
                  disableTabindex
                  @onClick=${s._toggleDropdown}
                ></${u}>
              ` : s._openWithSearch ? l`
                <${u}
                  class="dss-icon-button dss-input-dropdown__toggle"
                  size="md"
                  label="Esborra la selecció"
                  hideTooltip
                  icon="close"
                  variant="primary"
                  ?disabled=${s._disabled || s._readonly}
                  disableTabindex
                  @onClick=${s._cleanInput}
                ></${u}>
              ` : r}
          </div>

          <${y}
            ariaLabel="Llista d'elements"
            id="dss-selector"
            class="${e(x)}"
            .isOpen=${s._showDropdown || s._openWithSearch}
            .multiple=${s._multiple}
            .tick=${s._tick}
            .deselectable=${s._deselectable}
            .disabled=${s._disabled}
            .elements=${s._filteredElements}
            .filtre=${(v = s._input) == null ? void 0 : v.value}
            .filterThreshold=${s._filterThreshold}
            .searchThreshold=${s._searchThreshold}
            .selectedValue=${s._selectedValue}
            .type=${s._type}
            .labelSelectAll=${s._labelSelectAll}
            .labelDeselectAll=${s._labelDeselectAll}
            .selectAll=${s._selectAll}
            ?advancedFilter=${s.advancedFilter}
            isDisplayed=${s._showDropdown}
            elementsSelected=${s._selectElements}
            boxStyle=${s._selectorStyle}
            boxShadow
            @onValueChange="${s._onSelectorChanges}"
            @keydown="${(g) => {
    g.key === "Escape" && s._handleBlurSelector(void 0, g);
  }}"
            @focusout=${s._handleFocusOut}
            ?readonly=${s._readonly}
          >
          </${y}>

      </div>

      ${s._helpText && !s._openWithSearch ? l`
            <div class="${e(k)}">
              <span>${s._helpText}</span>
            </div>
          ` : null}

    </div>
  `;
};
export {
  A as template
};
//# sourceMappingURL=input-dropdown.template.js.map
